module.exports = __webpack_public_path__ + "img/cabinet_disconnect.5b8a4143.svg";